import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=99e02d2e&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=ts&"
export * from "./QuickNav.vue?vue&type=script&lang=ts&"
import style0 from "./QuickNav.vue?vue&type=style&index=0&id=99e02d2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e02d2e",
  null
  
)

export default component.exports